import React, { useEffect, useState ,useRef} from 'react';
import { useNavigate } from 'react-router';
import selectMaterial from "../assets/sounds/select_material.wav"
import hoverSound from "../assets/sounds/hover.wav"
const HomePage = () => {
  const [stars, setStars] = useState([]);
  const navigator = useNavigate() 
  useEffect(() => {
    // إنشاء النجوم
    const newStars = [];
    for (let i = 0; i < 50; i++) {
      newStars.push({
        id: i,
        size: Math.random() * 3 + 2,
        left: Math.random() * 100,
        top: Math.random() * 100,
        delay: Math.random() * 3
      });
    }
    setStars(newStars);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
 }, []);
/*
 "رياضيات 1: الأنماط والأعداد حتى ٩"
    "رياضيات 2: الأعداد حتى ١٢ والعمليات الأولية"
      "رياضيات 3: الأعداد حتى ٩٩ والمفاهيم المتقدمة"
*/
  const categories = [
    { id: 1, name:  "رياضيات 1: الأنماط والأعداد حتى ٩", icon: '🔢', color: 'math' },
    { id: 2, name:   "رياضيات 2: الأعداد حتى ١٢ والعمليات الأولية", icon: '🔢', color: 'math' },
    { id: 3, name:   "رياضيات 3: الأعداد حتى ٩٩ والمفاهيم المتقدمة", icon: '🔢', color: 'math' },
    { id: 4, name: 'الاجتماعيات', icon: '🌍', color: 'social' },
    { id: 5, name: 'اللغة العربية', icon: '📚', color: 'arabic' },
    { id: 6, name: 'اللغة الإنجليزية', icon: '🔤', color: 'english' },
    { id: 7, name: 'العلوم', icon: '🔬', color: 'science' }
  ];

  const floatingShapes = [
    { icon: '⭐', left: '10%', top: '20%', size: '3em', delay: 0 },
    { icon: '🎈', left: '80%', top: '15%', size: '2.5em', delay: 2 },
    { icon: '🌈', left: '15%', top: '70%', size: '3em', delay: 4 },
    { icon: '☁️', left: '85%', top: '65%', size: '2.5em', delay: 6 },
    { icon: '🦋', left: '50%', top: '80%', size: '3em', delay: 8 }
  ];

  const selectCategory = (categoryName) => { 
    const sparkle = new Audio(selectMaterial);
    sparkle.play();
    navigator("/category/"+categoryName)
 };

  return (
    <div className="min-h-screen p-5 relative overflow-hidden" style={{
      background: 'linear-gradient(45deg, #ff9a9e 0%, #fad0c4 25%, #ffecd2 50%, #fcb69f 75%, #ff9a9e 100%)',
      backgroundSize: '400% 400%',
      animation: 'gradientShift 15s ease infinite',
      direction: 'rtl'
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Tajawal:wght@400;700;900&display=swap');

        body {
          font-family: 'Tajawal', sans-serif;
        }

        @keyframes gradientShift {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }

        @keyframes twinkle {
          0%, 100% { opacity: 0.3; transform: scale(1); }
          50% { opacity: 1; transform: scale(1.5); }
        }

        @keyframes gradientMove {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }

        @keyframes rainbow {
          0% { filter: hue-rotate(0deg); }
          100% { filter: hue-rotate(360deg); }
        }

        @keyframes shine {
          0% { transform: translate(-50%, -50%) scale(0); }
          100% { transform: translate(50%, 50%) scale(1); }
        }

        @keyframes wiggle {
          0%, 100% { transform: rotate(-5deg); }
          50% { transform: rotate(5deg); }
        }

        @keyframes jump {
          0%, 100% { transform: translateY(0) scale(1); }
          50% { transform: translateY(-30px) scale(1.2) rotate(360deg); }
        }

        @keyframes sparkleAnim {
          0% { opacity: 0; transform: scale(0) rotate(0deg); }
          50% { opacity: 1; }
          100% { opacity: 0; transform: scale(1.5) rotate(180deg); }
        }

        @keyframes popIn {
          0% { 
            opacity: 0; 
            transform: scale(0) rotate(-180deg);
          }
          100% { 
            opacity: 1; 
            transform: scale(1) rotate(0deg);
          }
        }

        @keyframes bounceIn {
          0% { 
            opacity: 0; 
            transform: scale(0.3) translateY(-100px);
          }
          50% {
            transform: scale(1.05) translateY(0);
          }
          70% {
            transform: scale(0.9);
          }
          100% { 
            opacity: 1; 
            transform: scale(1);
          }
        }

        @keyframes floatShapes {
          0%, 100% { transform: translate(0, 0) rotate(0deg); }
          25% { transform: translate(100px, 100px) rotate(90deg); }
          50% { transform: translate(200px, 0) rotate(180deg); }
          75% { transform: translate(100px, -100px) rotate(270deg); }
        }

        .star {
          animation: twinkle 3s infinite;
        }

        .main-title {
          background: linear-gradient(45deg, #ff6b6b, #ee5a6f, #c44569, #ff6b6b);
          background-size: 300% 300%;
          animation: gradientMove 3s ease infinite;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-shadow: 4px 4px 0px rgba(255,255,255,0.5);
        }

        .subtitle {
          animation: float 3s ease-in-out infinite;
        }

        .rainbow-line {
          animation: rainbow 3s linear infinite;
        }

        .category-card {
          animation: popIn 0.6s ease backwards;
          transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
        }

        .category-card:hover {
          transform: translateY(-20px) scale(1.1);
          box-shadow: 0 25px 50px rgba(0,0,0,0.3);
        }

        .category-card:active {
          transform: scale(0.95);
        }

        .category-card::before {
          content: '';
          position: absolute;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          background: radial-gradient(circle, rgba(255,255,255,0.3) 0%, transparent 70%);
          opacity: 0;
          transition: opacity 0.5s;
        }

        .category-card:hover::before {
          opacity: 1;
          animation: shine 1.5s ease infinite;
        }

        .category-icon {
          animation: wiggle 2s ease-in-out infinite;
          filter: drop-shadow(0 5px 10px rgba(0,0,0,0.2));
        }

        .category-card:hover .category-icon {
          animation: jump 0.6s ease;
        }

        .sparkle {
          animation: sparkleAnim 1.5s ease-out infinite;
        }

        .shape {
          animation: floatShapes 20s infinite ease-in-out;
        }

        .category-card:nth-child(1) { animation-delay: 0.1s; }
        .category-card:nth-child(2) { animation-delay: 0.2s; }
        .category-card:nth-child(3) { animation-delay: 0.3s; }
        .category-card:nth-child(4) { animation-delay: 0.4s; }
        .category-card:nth-child(5) { animation-delay: 0.5s; }

        .math { 
          background: linear-gradient(135deg, #ff6b9d 0%, #ffa07a 100%);
          border-color: #ff1744;
        }
        .social { 
          background: linear-gradient(135deg, #4fc3f7 0%, #29b6f6 100%);
          border-color: #01579b;
        }
        .arabic { 
          background: linear-gradient(135deg, #81c784 0%, #66bb6a 100%);
          border-color: #2e7d32;
        }
        .english { 
          background: linear-gradient(135deg, #ffb74d 0%, #ffa726 100%);
          border-color: #e65100;
        }
        .science { 
          background: linear-gradient(135deg, #ba68c8 0%, #ab47bc 100%);
          border-color: #6a1b9a;
        }
      `}</style>

      {/* النجوم المتلألئة */}
      <div className="fixed top-0 left-0 w-full h-full pointer-events-none z-10">
        {stars.map(star => (
          <div
            key={star.id}
            className="star absolute bg-white rounded-full"
            style={{
              width: `${star.size}px`,
              height: `${star.size}px`,
              left: `${star.left}%`,
              top: `${star.top}%`,
              animationDelay: `${star.delay}s`
            }}
          />
        ))}
      </div>

      {/* الأشكال الطائرة */}
      <div className="fixed w-full h-full top-0 left-0 pointer-events-none z-10">
        {floatingShapes.map((shape, index) => (
          <div
            key={index}
            className="shape absolute opacity-30"
            style={{
              left: shape.left,
              top: shape.top,
              fontSize: shape.size,
              animationDelay: `${shape.delay}s`
            }}
          >
            {shape.icon}
          </div>
        ))}
      </div>

      <div className="max-w-7xl mx-auto relative z-20">
        {/* العنوان */}
        <header className="text-center mb-12" style={{ animation: 'bounceIn 1.2s ease' }}>
          <h1 className="main-title text-6xl font-black mb-4" style={{ transform: 'rotate(-2deg)' }}>
            🎨عالم طفلي المبدع 🚀
          </h1>
       
          <p className="subtitle text-3xl font-bold text-white" style={{ textShadow: '3px 3px 0px rgba(0,0,0,0.2)' }}>
            ✨ اختر المادة المفضلة لديك! ✨
          </p>
        </header>

        {/* البطاقات */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 p-5">
          {categories.map(category => (
            <CategoryCard
              key={category.id}
              name={category.name}
              icon={category.icon}
              color={category.color}
              onClick={() => selectCategory(category.name)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

const CategoryCard = ({ name, icon, color, onClick }) => {
  const [sparkles, setSparkles] = useState([]);
  const hoverSoundObject =  useRef(new Audio(hoverSound));

  useEffect(() => {
    const interval = setInterval(() => {
      const newSparkle = {
        id: Date.now(),
        left: Math.random() * 100,
        top: Math.random() * 100,
        delay: Math.random() * 0.5
      };
      setSparkles(prev => [...prev, newSparkle]);
      
      setTimeout(() => {
        setSparkles(prev => prev.filter(s => s.id !== newSparkle.id));
      }, 1500);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className={`category-card ${color} relative bg-white rounded-3xl p-10 text-center cursor-pointer overflow-hidden`}
      style={{
        boxShadow: '0 15px 35px rgba(0,0,0,0.2)',
        border: '6px solid transparent'
      }}
      onClick={onClick}
        onMouseEnter={() => {
        hoverSoundObject.current.currentTime = 0; // reset so it can replay quickly
        hoverSoundObject.current.play();
      }}
    >
      {/* البريق */}
      <div className="absolute w-full h-full top-0 left-0 pointer-events-none">
        {sparkles.map(sparkle => (
          <div
            key={sparkle.id}
            className="sparkle absolute w-2.5 h-2.5 bg-yellow-300 rounded-full opacity-0"
            style={{
              left: `${sparkle.left}%`,
              top: `${sparkle.top}%`,
              animationDelay: `${sparkle.delay}s`
            }}
          />
        ))}
      </div>

      <div className="category-icon text-8xl mb-5 inline-block">
        {icon}
      </div>
      <div className="text-4xl font-black text-white" style={{ textShadow: '3px 3px 6px rgba(0,0,0,0.3)', letterSpacing: '1px' }}>
        {name}
      </div>
    </div>
  );
};

export default HomePage;